let watermark = {}

let setWatermark = (str, str2, str3) => {
    let id = '1.53452384164.183412416';

    // 查看页面上有没有，如果有则删除
    if (document.getElementById(id) !== null) {
        document.body.removeChild(document.getElementById(id));
    }

    //创建一个画布
    let can = document.createElement('canvas');
    //设置每一块画布的长宽
    can.width = 285;
    can.height = 190;
    can.style.display = "none";//隐藏画布本身

    // 获取canvas画布
    let cans = can.getContext('2d');
    //旋转角度
    cans.rotate(-22 * Math.PI / 180);
    // 设置字体
    cans.font = '14px "Fira Sans"';
    //设置填充绘画的颜色、渐变（透明度）或者模式
    cans.fillStyle = 'rgba(200, 200, 200, 0.40)';
    //设置文本内容的当前对齐方式
    cans.textAlign = 'left';
    //设置在绘制文本时使用的当前文本基线
    cans.textBaseline = 'Middle';
    //在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
    //cans.fillText(str, can.width / 8, can.height / 2);
    cans.fillText(str, 0, 4 * can.height / 5) // 绘制文字
    cans.fillText(str2, 0, 4 * can.height / 5 + 22) // 绘制文字
    cans.fillText(str3, 0, 4 * can.height / 5 + 44) // 绘制文字

    let div = document.createElement('div');
    div.id = id;
    div.style.pointerEvents = 'none';// 取消所有事件
    div.style.top = '5px';
    div.style.left = '0px';
    div.style.position = 'fixed';
    div.style.zIndex = '100000';
    div.style.width = document.documentElement.clientWidth + 'px';
    div.style.height = document.documentElement.clientHeight + 'px';
    div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
    document.body.appendChild(div);
    return id;
}

// 该方法只允许调用一次
watermark.set = (str, str2, str3) => {
    let id = setWatermark(str, str2, str3);
    setInterval(() => {
        if (document.getElementById(id) === null) {
            id = setWatermark(str, str2, str3);
        }
    }, 500);
    // 监听页面大小的变化
    window.onresize = () => {
        setWatermark(str, str2, str3);
    };
}

export default watermark;